module.exports = __webpack_public_path__ + "static/media/BradescoSaude.5f17058c.svg";